module.exports = __webpack_public_path__ + "static/img/35-3.3da00d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/35-3.jpg
// module id = G/o4
// module chunks = 0